(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labchest-quote-request"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const quotePayload = (form) => {
        const itemsElement = form.querySelector('[data-labchest-quote-items]');
        const fields = new FormData(form);
        return {
          name: String(fields.get('name') || ''),
          email: String(fields.get('email') || ''),
          institution: String(fields.get('institution') || ''),
          department: String(fields.get('department') || ''),
          phone: String(fields.get('phone') || ''),
          deliveryAddress1: String(fields.get('deliveryAddress1') || ''),
          deliveryAddress2: String(fields.get('deliveryAddress2') || ''),
          deliveryCity: String(fields.get('deliveryCity') || ''),
          deliveryRegion: String(fields.get('deliveryRegion') || ''),
          deliveryPostalCode: String(fields.get('deliveryPostalCode') || ''),
          deliveryCountry: String(fields.get('deliveryCountry') || ''),
          sameBillingAddress: fields.get('sameBillingAddress') === 'true',
          billingAddress1: String(fields.get('billingAddress1') || ''),
          billingAddress2: String(fields.get('billingAddress2') || ''),
          billingCity: String(fields.get('billingCity') || ''),
          billingRegion: String(fields.get('billingRegion') || ''),
          billingPostalCode: String(fields.get('billingPostalCode') || ''),
          billingCountry: String(fields.get('billingCountry') || ''),
          poNumber: String(fields.get('poNumber') || ''),
          paymentTerms: String(fields.get('paymentTerms') || ''),
          deliveryTiming: String(fields.get('deliveryTiming') || ''),
          notes: String(fields.get('notes') || ''),
          website: String(fields.get('website') || ''),
          purchaseOrderRequired: fields.get('purchaseOrderRequired') === 'true',
          currency: form.dataset.currency,
          discountCodes: form.quoteDiscountCodes || [],
          shippingSelection: String(fields.get('shippingSelection') || ''),
          expectedTotal: String(fields.get('expectedTotal') || ''),
          items: JSON.parse(itemsElement.textContent)
        };

    };
    const shippingStates = new WeakMap();
    const shippingSnapshot = (form) => {
      const payload = quotePayload(form);
      const keys = ['email', 'deliveryAddress1', 'deliveryAddress2', 'deliveryCity', 'deliveryRegion', 'deliveryPostalCode', 'deliveryCountry', 'sameBillingAddress', 'billingAddress1', 'billingAddress2', 'billingCity', 'billingRegion', 'billingPostalCode', 'billingCountry', 'currency', 'items', 'discountCodes'];
      return JSON.stringify(Object.fromEntries(keys.map((key) => [key, payload[key]])));
    };
    const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency, currencyDisplay: 'code'
    }).format(Number(amount));

    const clearDocument = (form) => {
      if (form.dataset.objectUrl) {
        URL.revokeObjectURL(form.dataset.objectUrl);
        delete form.dataset.objectUrl;
      }
      form.querySelector('[data-labchest-quote-status]').replaceChildren();
      form.querySelector('button[type="submit"]').hidden = false;
    };

    const showShipping = (form) => {
      const state = shippingStates.get(form);
      const selection = form.querySelector('[data-quote-shipping-select]').value;
      const rate = state?.rates?.find((option) => option.selection === selection);
      if (!rate) return;
      form.elements.namedItem('expectedTotal').value = rate.total;
      form.querySelector('[data-quote-subtotal]').textContent = money(rate.subtotal, form.dataset.currency);
      form.querySelector('[data-quote-shipping-price]').textContent = money(rate.shipping, form.dataset.currency);
      form.querySelector('[data-quote-tax]').textContent = money(rate.tax, form.dataset.currency);
      form.querySelector('[data-quote-tax-label]').textContent = rate.taxesIncluded ? form.dataset.taxIncludedLabel : form.dataset.taxLabel;
      form.querySelector('[data-quote-total]').textContent = money(rate.total, form.dataset.currency);
      form.querySelector('[data-quote-shipping-options]').hidden = false;
    };

    const invalidateShipping = (form) => {
      const previous = shippingStates.get(form);
      previous?.controller?.abort();
      clearTimeout(previous?.timer);
      const preferred = form.querySelector('[data-quote-shipping-select]').value || previous?.preferred || '';
      const state = { preferred };
      shippingStates.set(form, state);
      form.querySelector('[data-quote-shipping-options]').hidden = true;
      form.elements.namedItem('expectedTotal').value = '';
      form.querySelector('[data-quote-shipping-status]').textContent = form.dataset.shippingPrompt;
      return state;
    };

    const refreshShipping = async (form) => {
      const previous = shippingStates.get(form);
      const preferred = form.querySelector('[data-quote-shipping-select]').value || previous?.preferred || '';
      previous?.controller?.abort();
      clearTimeout(previous?.timer);
      const state = { controller: new AbortController(), preferred, snapshot: shippingSnapshot(form) };
      shippingStates.set(form, state);
      const message = form.querySelector('[data-quote-shipping-status]');
      const retry = form.querySelector('[data-quote-shipping-retry]');
      const options = form.querySelector('[data-quote-shipping-options]');
      options.hidden = true;
      retry.hidden = true;
      const payload = quotePayload(form);
      if (form.hidden || !payload.deliveryAddress1.trim() || !payload.deliveryCity.trim() || !payload.deliveryCountry.trim()) {
        message.textContent = form.dataset.shippingPrompt;
        return false;
      }
      if (!form.dataset.endpoint) { message.textContent = form.dataset.missingEndpoint; return false; }
      message.textContent = form.dataset.shippingLoading;
      try {
        const endpoint = `${form.dataset.endpoint.replace(/\/$/, '')}/rates`;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
          signal: state.controller.signal
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || form.dataset.genericError);
        if (result.currency !== form.dataset.currency || !Array.isArray(result.rates) || !result.rates.length) throw new Error(form.dataset.genericError);
        if (shippingStates.get(form) !== state) return false;
        state.rates = result.rates;
        const select = form.querySelector('[data-quote-shipping-select]');
        select.replaceChildren(...result.rates.map((rate) => {
          const option = document.createElement('option');
          option.value = rate.selection;
          option.textContent = `${rate.title} · ${money(rate.shipping, result.currency)}`;
          return option;
        }));
        select.value = result.rates.some((rate) => rate.selection === preferred) ? preferred : result.rates[0].selection;
        showShipping(form);
        message.textContent = form.dataset.shippingReady;
        return true;
      } catch (error) {
        if (shippingStates.get(form) !== state) return false;
        form.elements.namedItem('expectedTotal').value = '';
        message.textContent = error instanceof Error ? error.message : form.dataset.genericError;
        retry.hidden = false;
        return false;
      }
    };

    const scheduleShipping = (form) => {
      const snapshot = shippingSnapshot(form);
      if (shippingStates.get(form)?.snapshot === snapshot) return;
      const state = invalidateShipping(form);
      state.snapshot = snapshot;
      state.timer = setTimeout(() => refreshShipping(form), 650);
    };

    const refreshes = new WeakMap();

    const refreshQuote = (section) => {
      const previous = refreshes.get(section);
      previous?.controller.abort();
      const state = { controller: new AbortController() };
      const form = section.querySelector('[data-labchest-quote-form]');
      const submit = form.querySelector('button[type="submit"]');
      submit.disabled = true;
      state.promise = (async () => {
        try {
          const url = new URL(section.dataset.cartUrl, window.location.origin);
          url.searchParams.set('section_id', section.dataset.quoteSectionId);
          const cartUrl = new URL(section.dataset.cartUrl, window.location.origin);
          cartUrl.pathname += '.js';
          const [response, cartResponse] = await Promise.all([
            fetch(url, { cache: 'no-store', signal: state.controller.signal }),
            fetch(cartUrl, { cache: 'no-store', signal: state.controller.signal })
          ]);
          if (!cartResponse.ok) throw new Error('Cart unavailable');
          const cart = await cartResponse.json();
          const discountCodes = (cart.discount_codes || []).map((discount) => discount.code).filter((code) => typeof code === 'string');
          if (!response.ok) throw new Error('Cart section unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const freshForm = html.querySelector('[data-labchest-quote-form]');
          const freshItems = freshForm?.querySelector('[data-labchest-quote-items]');
          const freshSummary = freshForm?.querySelector('[data-quote-summary]');
          if (!freshItems || !freshSummary) throw new Error('Cart section incomplete');
          const items = JSON.parse(freshItems.textContent);
          if (!Array.isArray(items)) throw new Error('Cart items unavailable');
          if (refreshes.get(section) !== state) return refreshes.get(section).promise;

          const itemsElement = form.querySelector('[data-labchest-quote-items]');
          const changed = itemsElement.textContent !== freshItems.textContent || form.dataset.currency !== freshForm.dataset.currency || JSON.stringify(form.quoteDiscountCodes || []) !== JSON.stringify(discountCodes);
          itemsElement.textContent = freshItems.textContent;
          form.dataset.currency = freshForm.dataset.currency;
          form.quoteDiscountCodes = discountCodes;
          form.querySelector('[data-quote-summary]').textContent = freshSummary.textContent;
          form.hidden = items.length === 0;
          section.querySelector('.labchest-quote__empty').hidden = items.length > 0;
          section.querySelector('[data-quote-sync-error]').hidden = true;
          if (changed) {
            scheduleShipping(form);
            if (form.dataset.objectUrl) {
              URL.revokeObjectURL(form.dataset.objectUrl);
              delete form.dataset.objectUrl;
            }
            form.querySelector('[data-labchest-quote-status]').replaceChildren();
            submit.hidden = false;
          }
          return items.length > 0;
        } catch (error) {
          if (refreshes.get(section) !== state) return refreshes.get(section).promise;
          section.querySelector('[data-quote-sync-error]').hidden = false;
          return false;
        } finally {
          if (refreshes.get(section) === state) submit.disabled = form.hidden || form.dataset.submitting === 'true';
        }
      })();
      refreshes.set(section, state);
      return state.promise;
    };

    const scheduleRefresh = () => {
      document.querySelectorAll('[data-quote-section-id]').forEach((section) => {
        clearTimeout(section.quoteRefreshTimer);
        section.quoteRefreshTimer = setTimeout(() => refreshQuote(section), 150);
      });
    };

    const initializeForms = (root) => root.querySelectorAll('[data-labchest-quote-form]').forEach((form) => {
      if (form.dataset.initialized === 'true') return;
      form.dataset.initialized = 'true';

      const billingToggle = form.querySelector('[name="sameBillingAddress"]');
      const billingFields = form.querySelector('[data-labchest-billing-fields]');
      const billingRequired = ['billingAddress1', 'billingCity', 'billingCountry'];

      const syncBillingFields = () => {
        const useDeliveryAddress = billingToggle.checked;
        billingFields.hidden = useDeliveryAddress;
        billingRequired.forEach((name) => {
          const field = form.elements.namedItem(name);
          if (field) field.required = !useDeliveryAddress;
        });
      };

      billingToggle.addEventListener('change', syncBillingFields);
      syncBillingFields();
      form.querySelector('button[type="submit"]').disabled = form.hidden;
      const shippingFields = ['email', 'deliveryAddress1', 'deliveryAddress2', 'deliveryCity', 'deliveryRegion', 'deliveryPostalCode', 'deliveryCountry', 'sameBillingAddress', 'billingAddress1', 'billingAddress2', 'billingCity', 'billingRegion', 'billingPostalCode', 'billingCountry'];
      form.addEventListener('input', (event) => {
        clearDocument(form);
        if (shippingFields.includes(event.target.name)) scheduleShipping(form);
      });
      form.addEventListener('change', (event) => {
        if (shippingFields.includes(event.target.name)) scheduleShipping(form);
      });
      form.querySelector('[data-quote-shipping-select]').addEventListener('change', () => { clearDocument(form); showShipping(form); });
      form.querySelector('[data-quote-shipping-retry]').addEventListener('click', () => refreshShipping(form));
      scheduleShipping(form);

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const status = form.querySelector('[data-labchest-quote-status]');
        const submit = form.querySelector('button[type="submit"]');

        if (form.dataset.submitting === 'true' || !form.reportValidity()) return;

        if (!form.dataset.endpoint) {
          status.textContent = form.dataset.missingEndpoint;
          return;
        }

        const previousTotal = form.elements.namedItem('expectedTotal').value;
        const previousSelection = form.querySelector('[data-quote-shipping-select]').value;
        form.dataset.submitting = 'true';
        submit.disabled = true;
        const section = form.closest('[data-quote-section-id]');
        clearTimeout(section.quoteRefreshTimer);
        if (!(await refreshQuote(section))) {
          delete form.dataset.submitting;
          submit.disabled = form.hidden;
          return;
        }

        if (!(await refreshShipping(form))) {
          delete form.dataset.submitting;
          submit.disabled = form.hidden;
          return;
        }
        if (!previousTotal || Number(previousTotal) !== Number(form.elements.namedItem('expectedTotal').value) || previousSelection !== form.querySelector('[data-quote-shipping-select]').value) {
          status.textContent = form.dataset.shippingReview;
          delete form.dataset.submitting;
          submit.disabled = form.hidden;
          return;
        }

        if (form.dataset.objectUrl) {
          URL.revokeObjectURL(form.dataset.objectUrl);
          delete form.dataset.objectUrl;
        }

        const payload = quotePayload(form);

        form.classList.add('is-loading');
        submit.disabled = true;
        status.textContent = '';

        try {
          const response = await fetch(form.dataset.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/pdf, application/json' },
            body: JSON.stringify(payload)
          });

          if (!response.ok) {
            let message = form.dataset.genericError;
            try {
              const result = await response.json();
              message = result.error || message;
              if (result.code === 'rates_changed') await refreshShipping(form);
            } catch (_error) {
              message = form.dataset.genericError;
            }
            throw new Error(message);
          }

          const contentType = response.headers.get('Content-Type') || '';
          if (!contentType.includes('application/pdf')) throw new Error(form.dataset.genericError);

          const pdf = await response.blob();
          const objectUrl = URL.createObjectURL(pdf);
          const filename = response.headers.get('X-Quote-Filename') || 'LabChest-Quotation.pdf';
          const reference = response.headers.get('X-Quote-Reference') || '';
          const download = document.createElement('a');
          download.className = 'link underlined-link';
          download.href = objectUrl;
          download.download = filename;
          download.textContent = form.dataset.downloadLabel;
          form.dataset.objectUrl = objectUrl;

          syncBillingFields();
          status.replaceChildren(document.createTextNode(`${form.dataset.successMessage}${reference ? ` ${reference}` : ''} `), download);
          if (!window.Shopify?.designMode) download.click();
          submit.hidden = true;
        } catch (error) {
          status.textContent = error instanceof Error ? error.message : form.dataset.genericError;
        } finally {
          form.classList.remove('is-loading');
          delete form.dataset.submitting;
          submit.disabled = form.hidden;
        }
      });
    });

    initializeForms(document);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
    }
    const cartObserver = new MutationObserver(scheduleRefresh);
    document.querySelectorAll('cart-items, #cart-icon-bubble').forEach((element) => {
      cartObserver.observe(element, { childList: true, subtree: true });
    });
    window.addEventListener('pageshow', scheduleRefresh);
    window.addEventListener('focus', scheduleRefresh);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) scheduleRefresh();
    });
    document.addEventListener('shopify:section:load', (event) => initializeForms(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labchest-shopping-tools"]) return;
  try {
    
(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const list = (value) => String(value || '').split(',').map((item) => item.trim()).filter(Boolean);
  const matches = (value, selected) => !list(selected).length || list(selected).includes(String(value));
  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const money = (amount, config) => new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(amount / 100);
  const text = (value, replacements = {}) => Object.entries(replacements).reduce((result, [key, item]) => result.replaceAll(`{${key}}`, item), value);
  const request = async (path, options = {}) => {
    const response = await fetch(root() + path, { ...options, headers: { Accept: 'application/json', ...options.headers } });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : 'Cart update failed');
    return data;
  };
  const cartIds = (cart) => new Set(cart.items.map((item) => Number(item.product_id)));
  const selectedVariants = (product, offer) => product.variants.filter((variant) => matches(variant.id, offer.variantIds));
  const uniqueOfferEntries = (offers, config, cart) => {
    const seen = new Set();
    const inCart = cartIds(cart);
    return offers.flatMap((offer) => offer.products.map((product) => ({ offer, product }))).filter(({ offer, product }) => {
      if (seen.has(product.id) || !product.available || (offer.hideInCart && inCart.has(product.id)) || (offer.hideTrigger && product.id === config.currentProduct?.id) || !selectedVariants(product, offer).some((variant) => variant.available)) return false;
      seen.add(product.id);
      return true;
    });
  };
  const eligibleOffer = (offer, placement, config, cart, products) => {
    const actualPlacement = ['notification', 'drawer'].includes(placement) ? 'drawer' : placement;
    if (!offer.enabled || !['all', actualPlacement].includes(offer.placement)) return false;
    if (!matches(config.country, offer.countries) || !matches(config.currency, offer.currencies)) return false;
    const conversion = Number(window.Shopify?.currency?.rate || 1);
    const total = cart.total_price / 100 / conversion;
    if (total < offer.minCart || (offer.maxCart > 0 && total > offer.maxCart)) return false;
    const triggers = actualPlacement === 'product' ? [config.currentProduct].filter(Boolean) : cart.items.map((item) => products.get(Number(item.product_id))).filter(Boolean);
    if (actualPlacement !== 'product' && !cart.item_count) return false;
    return triggers.some((product) => (!offer.triggerProduct || Number(offer.triggerProduct) === product.id) && (!offer.triggerCollection || product.collections.includes(offer.triggerCollection)) && !list(offer.excludedTags).some((tag) => product.tags.includes(tag)));
  };
  window.LabChestShoppingRules = { eligibleOffer, selectedVariants, matches, uniqueOfferEntries };
  class ShoppingConfig extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-lc-config]').textContent);
      const decoder = document.createElement('textarea');
      for (const [key, value] of Object.entries(this.config.strings)) { decoder.innerHTML = value; this.config.strings[key] = decoder.value; }
      this.config.shipping = this.config.shipping.filter(Boolean);
      this.config.offers = this.config.offers.filter(Boolean);
      this.cart = this.config.cart;
      this.products = new Map();
      for (const offer of this.config.offers) for (const product of offer.products) this.products.set(product.id, product);
      if (this.config.currentProduct) this.products.set(this.config.currentProduct.id, this.config.currentProduct);
      this.productRequests = new Map();
      this.recommendationRequests = new Map();
      this.widgets = new Set();
      this.syncVersion = 0;
      this.listener = (event) => {
        const fresh = event?.cartData;
        if (fresh && Array.isArray(fresh.items) && typeof fresh.total_price === 'number') {
          this.cart = fresh;
          this.failure = false;
          for (const widget of this.widgets) if (widget.isConnected) this.render(widget);
        }
        this.scheduleSync();
      };
      this.pageListener = () => { if (document.visibilityState !== 'hidden') this.scheduleSync(); };
      window.addEventListener('pageshow', this.listener);
      window.addEventListener('focus', this.pageListener);
      document.addEventListener('visibilitychange', this.pageListener);
      document.addEventListener('shopify:section:load', this.listener);
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.listener);
      this.observer = new MutationObserver((records) => {
        if (records.some((record) => !record.target.closest?.('labchest-shopping-tools') && (record.target.closest?.('cart-items, cart-drawer-items, #cart-icon-bubble, #cart-notification-product') || [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('cart-items, cart-drawer-items') || node.querySelector?.('cart-items, cart-drawer-items')))))) this.scheduleSync();
      });
      this.observer.observe(document.body, { subtree: true, childList: true, characterData: true });
      window.LabChestShopping = this;
      for (const widget of document.querySelectorAll('labchest-shopping-tools')) this.register(widget);
      this.sync();
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.observer?.disconnect();
      clearTimeout(this.timer);
      window.removeEventListener('pageshow', this.listener);
      window.removeEventListener('focus', this.pageListener);
      document.removeEventListener('visibilitychange', this.pageListener);
      document.removeEventListener('shopify:section:load', this.listener);
      if (window.LabChestShopping === this) delete window.LabChestShopping;
    }
    register(widget) {
      this.widgets.add(widget);
      for (const name of ['--lc-background', '--lc-foreground', '--lc-accent', '--lc-background-rgb', '--lc-accent-rgb']) widget.style.setProperty(name, this.style.getPropertyValue(name));
      this.render(widget);
    }
    scheduleSync() {
      this.syncVersion++;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.sync(), 180);
    }
    async sync() {
      const version = ++this.syncVersion;
      try {
        const cart = await request('cart.js');
        if (version !== this.syncVersion || !this.isConnected) return;
        this.config.currency = cart.currency;
        this.cart = cart;
        await Promise.all(cart.items.map((item) => this.loadProduct(item.handle)));
        if (version !== this.syncVersion) return;
        this.failure = false;
        for (const widget of this.widgets) if (widget.isConnected) this.render(widget);
      } catch (_) {
        if (version !== this.syncVersion) return;
        this.failure = true;
        for (const widget of this.widgets) if (widget.isConnected && !widget.hidden) this.render(widget);
      }
    }
    async loadProduct(handle) {
      if (!handle) return null;
      if (!this.productRequests.has(handle)) this.productRequests.set(handle, (async () => {
        const response = await fetch(`${root()}products/${encodeURIComponent(handle)}?section_id=labchest-offer-data`);
        if (!response.ok) throw new Error('Product unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const node = doc.querySelector('[data-lc-product]');
        if (!node) throw new Error('Product unavailable');
        const product = JSON.parse(node.textContent);
        this.products.set(product.id, product);
        return product;
      })().catch(() => { this.productRequests.delete(handle); return null; }));
      return this.productRequests.get(handle);
    }
    async recommendations(productId) {
      if (!productId) return [];
      if (!this.recommendationRequests.has(productId)) this.recommendationRequests.set(productId, (async () => {
        const data = await request(`recommendations/products.json?product_id=${productId}&limit=10&intent=related`);
        const products = await Promise.all((data.products || []).map((product) => this.loadProduct(product.handle)));
        return products.filter(Boolean);
      })().catch(() => { this.recommendationRequests.delete(productId); return []; }));
      return this.recommendationRequests.get(productId);
    }
    threshold() {
      return this.config.shipping.find((rule) => rule.enabled && rule.currency === this.config.currency && rule.amount > 0 && matches(this.config.country, rule.countries));
    }
    shippingTotal(rule) {
      const excluded = list(rule.excludedTags);
      if (!excluded.length) return this.cart.total_price;
      const removed = this.cart.items.filter((item) => this.products.get(Number(item.product_id))?.tags.some((tag) => excluded.includes(tag))).reduce((sum, item) => sum + item.final_line_price, 0);
      return Math.max(0, this.cart.total_price - removed);
    }
    shipping(widget) {
      if (!['product', 'cart-top', 'notification'].includes(widget.dataset.placement)) return '';
      const enabled = widget.dataset.placement === 'product' ? this.config.shippingProduct : widget.dataset.placement === 'notification' ? this.config.shippingNotification : this.config.shippingCart;
      const rule = this.threshold();
      if (!enabled || !rule || (widget.dataset.placement !== 'product' && !this.cart.item_count)) return '';
      if (this.failure) return `<div class="lc-panel"><p role="status">${esc(this.config.strings.error)}</p><a class="lc-link" href="">${esc(this.config.strings.refresh)}</a></div>`;
      const total = this.shippingTotal(rule);
      const target = Math.round(rule.amount * 100);
      const remaining = Math.max(0, target - total);
      const percent = Math.min(100, Math.floor(total / target * 100));
      const key = remaining === 0 ? 'shippingReached' : total > 0 ? 'shippingProgress' : 'shippingInitial';
      const message = text(this.config.strings[rule.estimated ? `${key}Estimated` : key], { amount: money(total > 0 ? remaining : target, this.config) });
      return `<div class="lc-panel lc-shipping"><p class="lc-shipping__title" role="status" aria-live="polite">${esc(message)}</p><div class="lc-progress" role="progressbar" aria-label="${esc(this.config.strings.shippingLabel)}" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${percent}" aria-valuetext="${esc(message)}"><span style="width:${percent}%"></span></div><small>${esc(this.config.strings.shippingNote)}</small></div>`;
    }
    card(product, offer, instance, index) {
      const variants = selectedVariants(product, offer);
      const variant = variants.find((item) => item.available);
      if (!variant) return '';
      const inputId = `lc-${instance}-${offer.id}-${product.id}-${index}`;
      const discount = offer.discountReady ? Number(offer.discountPercent || 0) : 0;
      const price = Math.round(variant.price * (1 - discount / 100));
      const quantity = variant.quantity_rule?.min || 1;
      const max = variant.quantity_rule?.max;
      const increment = variant.quantity_rule?.increment || 1;
      const bundle = offer.kind === 'bundle';
      return `<div class="lc-card" data-product="${product.id}" data-offer="${esc(offer.id)}" data-variant="${variant.id}">
        ${bundle ? `<input class="lc-card__check" type="checkbox" checked aria-label="${esc(text(this.config.strings.select, {product: product.title}))}">` : ''}
        <a class="lc-card__image" href="${esc(product.url)}" tabindex="-1" aria-hidden="true">${product.image ? `<img src="${esc(product.image)}" alt="" width="76" height="76" loading="lazy">` : ''}</a>
        <div class="lc-card__details"><a class="lc-card__title" href="${esc(product.url)}">${esc(product.title)}</a>
        ${variants.length > 1 ? `<label class="visually-hidden" for="${inputId}">${esc(product.title)}: ${esc(this.config.strings.variant)}</label><select id="${inputId}" class="lc-select" data-variant-selector>${variants.map((item) => `<option value="${item.id}" ${!item.available ? 'disabled' : ''} ${item.id === variant.id ? 'selected' : ''}>${esc(item.title)}${!item.available ? ' · '+esc(this.config.strings.unavailable) : ''}</option>`).join('')}</select>` : variant.title !== 'Default Title' ? `<small>${esc(variant.title)}</small>` : ''}
        <div class="lc-price" data-price>${discount ? `<s>${esc(money(variant.price, this.config))}</s>` : ''}<span>${esc(money(price, this.config))}</span></div>
        ${discount ? `<small class="lc-badge">${esc(text(this.config.strings.discount, {percent: discount}))} · ${esc(text(this.config.strings.limit, {quantity: offer.discountLimit}))}</small>` : ''}</div>
        <div class="lc-card__action">${offer.quantityPicker ? `<label class="visually-hidden" for="${inputId}-qty">${esc(this.config.strings.quantity)}</label><input id="${inputId}-qty" type="number" class="lc-quantity" min="${quantity}" step="${increment}" value="${quantity}" ${max ? 'max="'+max+'"' : ''} data-quantity>` : ''}
        ${bundle ? '' : `<button class="button button--secondary lc-add" type="button" data-lc-add aria-label="${esc(this.config.strings.add+' '+product.title)}" ${offer.discountPercent && !offer.discountReady ? 'disabled' : ''}><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg><span>${esc(this.config.strings.add)}</span></button>`}</div></div>`;
    }
    group(widget, offers) {
      const bundle = offers.find((offer) => offer.kind === 'bundle');
      const entries = uniqueOfferEntries(bundle ? [bundle] : offers, this.config, this.cart);
      if (!entries.length) return '';
      const cards = entries.map(({ product, offer }, index) => this.card(product, offer, widget.instanceId, index)).join('');
      if (!cards) return '';
      const headingId = `lc-heading-${widget.instanceId}`;
      const title = new Set(entries.map(({ offer }) => offer.id)).size === 1 ? entries[0].offer.title : this.config.strings.suggestions;
      return `<section class="lc-panel lc-offer" aria-labelledby="${headingId}" data-offer-group="combined"><div class="lc-offer__header"><h3 id="${headingId}">${esc(title)}</h3>${entries.length > 1 ? `<div class="lc-navigation"><button type="button" class="button button--secondary lc-nav" data-lc-direction="-1" aria-label="${esc(this.config.strings.previous)}">‹</button><button type="button" class="button button--secondary lc-nav" data-lc-direction="1" aria-label="${esc(this.config.strings.next)}">›</button></div>` : ''}</div><div class="lc-cards">${cards}</div>${bundle ? `<button class="button button--secondary lc-bundle" type="button" data-lc-bundle>${esc(this.config.strings.add)}</button>` : ''}</section>`;
    }
    paint(widget, offers) {
      const selected = [...widget.querySelectorAll('.lc-card')].map((card) => ({ product: card.dataset.product, variant: card.dataset.variant }));
      const active = document.activeElement;
      const hadFocus = widget.contains(active);
      const focusId = active?.id;
      const focusVariant = active?.closest?.('.lc-card')?.dataset.variant;
      const markup = this.shipping(widget) + this.group(widget, offers);
      widget.innerHTML = `${markup}<div class="lc-live" role="status" aria-live="polite"></div><div class="lc-errors" role="alert" hidden></div>`;
      widget.hidden = !markup;
      for (const saved of selected) {
        const card = [...widget.querySelectorAll('.lc-card')].find((item) => item.dataset.product === saved.product);
        const selector = card?.querySelector('[data-variant-selector]');
        if (selector?.querySelector(`option[value="${saved.variant}"]:not(:disabled)`)) {
          selector.value = saved.variant;
          this.updateVariant(card);
        }
      }
      for (const group of widget.querySelectorAll('[data-offer-group]')) widget.updateBundle(group);
      if (hadFocus) (focusId && document.getElementById(focusId) || widget.querySelector(`[data-variant="${focusVariant}"] [data-lc-add]`) || widget.querySelector('button, a'))?.focus();
    }
    updateVariant(card) {
      const selector = card.querySelector('[data-variant-selector]');
      if (!selector) return;
      card.dataset.variant = selector.value;
      const product = this.products.get(Number(card.dataset.product));
      const variant = product.variants.find((item) => item.id === Number(selector.value));
      const offer = this.offer(card.dataset.offer);
      const discount = offer.discountReady ? offer.discountPercent : 0;
      card.querySelector('[data-price]').innerHTML = `${discount ? '<s>'+esc(money(variant.price, this.config))+'</s>' : ''}<span>${esc(money(Math.round(variant.price * (1 - discount / 100)), this.config))}</span>`;
      const quantity = card.querySelector('[data-quantity]');
      if (quantity) { quantity.min = variant.quantity_rule.min; quantity.step = variant.quantity_rule.increment; quantity.value = variant.quantity_rule.min; if (variant.quantity_rule.max) quantity.max = variant.quantity_rule.max; else quantity.removeAttribute('max'); }
    }
    render(widget) {
      if (!this.config.enabled) { widget.hidden = true; return; }
      if (widget.busy) return;
      const signature = JSON.stringify([this.cart.items.map((item) => [item.key, item.quantity, item.final_line_price]), this.cart.total_price, this.config.currency, this.failure]);
      if (widget.signature === signature) return;
      widget.signature = signature;
      const offers = widget.dataset.placement === 'cart-top' ? [] : this.config.offers.filter((offer) => eligibleOffer(offer, widget.dataset.placement, this.config, this.cart, this.products));
      this.paint(widget, offers);
      const seed = widget.dataset.placement === 'product' ? this.config.currentProduct?.id : this.cart.items[0]?.product_id;
      const canRecommend = this.config.recommendations && this.threshold() && widget.dataset.placement === 'product';
      if (canRecommend && !this.failure) {
        this.recommendations(seed).then((products) => {
          if (!widget.isConnected || widget.signature !== signature || widget.busy) return;
          const manualIds = new Set(offers.flatMap((offer) => offer.products.map((product) => product.id)));
          const gap = Math.max(0, this.threshold().amount * 100 - this.shippingTotal(this.threshold()));
          const ranked = products.filter((product) => !manualIds.has(product.id) && !cartIds(this.cart).has(product.id) && product.id !== this.config.currentProduct?.id && product.available).sort((a, b) => {
            const priceA = a.variants.find((v) => v.available)?.price || 0;
            const priceB = b.variants.find((v) => v.available)?.price || 0;
            return Math.abs(priceA - gap) - Math.abs(priceB - gap);
          }).slice(0, this.config.recommendationLimit);
          const offer = { id: 'shipping-recommendations', title: this.config.strings.suggestions, hideInCart: true, hideTrigger: true, kind: 'cross_sell', products: ranked, variantIds: '', quantityPicker: false, discountPercent: 0 };
          this.currentRecommendations ||= new Map();
          for (const product of ranked) this.currentRecommendations.set(product.id, product);
          this.paint(widget, [...offers, offer]);
        });
      }
    }
    offer(id) {
      return this.config.offers.find((offer) => offer.id === id) || { id, products: [...(this.currentRecommendations?.values() || [])], variantIds: '', discountPercent: 0 };
    }
    async add(widget, cards, button) {
      if (widget.busy || !cards.length) return;
      const entries = cards.map((card) => {
        const product = this.products.get(Number(card.dataset.product));
        const variant = product?.variants.find((item) => item.id === Number(card.dataset.variant));
        const quantityInput = card.querySelector('[data-quantity]');
        const quantity = Number(quantityInput?.value || variant?.quantity_rule?.min || 1);
        const min = variant?.quantity_rule?.min || 1;
        const increment = variant?.quantity_rule?.increment || 1;
        if (!variant?.available || !Number.isInteger(quantity) || quantity < min || quantity % increment !== 0 || (variant.quantity_rule?.max && quantity > variant.quantity_rule.max)) throw new Error('Invalid quantity');
        const offer = this.offer(card.dataset.offer);
        if (offer.discountPercent && !offer.discountReady) throw new Error('Offer unavailable');
        if (quantityInput && !quantityInput.reportValidity()) throw new Error('Invalid quantity');
        return { id: variant.id, quantity, properties: { '_LabChest offer': card.dataset.offer } };
      });
      widget.busy = true;
      widget.querySelectorAll('button, input, select').forEach((element) => element.disabled = true);
      const original = button.innerHTML;
      button.textContent = this.config.strings.adding;
      const cartItems = document.querySelector('cart-items');
      const cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const sections = cartItems ? cartItems.getSectionsToRender().map((item) => item.section) : cartUI?.getSectionsToRender().map((item) => item.id) || ['cart-icon-bubble'];
      const errors = widget.querySelector('.lc-errors');
      if (errors) errors.hidden = true;
      let completed = false;
      try {
        const response = await request('cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: entries, sections: [...new Set(sections)].slice(0, 5), sections_url: window.location.pathname }) });
        completed = true;
        const live = widget.querySelector('.lc-live');
        if (live) live.textContent = this.config.strings.added;
        const validSections = response.sections && Object.values(response.sections).every(Boolean);
        if (!validSections) { window.location.assign(root() + 'cart'); return; }
        if (cartItems) {
          for (const section of cartItems.getSectionsToRender()) {
            const target = document.getElementById(section.id);
            const dest = target?.querySelector(section.selector) || target;
            const source = new DOMParser().parseFromString(response.sections[section.section], 'text/html').querySelector(section.selector);
            if (!dest || !source) { window.location.assign(root() + 'cart'); return; }
            dest.innerHTML = source.innerHTML;
          }
        } else if (cartUI && !widget.closest('cart-notification')) {
          const item = response.items?.[0] || response;
          cartUI.setActiveElement(document.querySelector('product-form [type="submit"]') || document.querySelector('#cart-icon-bubble'));
          cartUI.renderContents({ ...response, key: item.key, id: item.id });
        }
        widget.busy = false;
        await this.sync();
        if (typeof publish === 'function') await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'labchest-shopping-tools', cartData: this.cart });
      } catch (error) {
        if (errors) { errors.innerHTML = `${esc(error.message === 'Cart update failed' ? this.config.strings.error : error.message)} <a class="lc-link" href="">${esc(this.config.strings.refresh)}</a>`; errors.hidden = false; }
      } finally {
        widget.busy = false;
        if (button.isConnected) button.innerHTML = original;
        widget.querySelectorAll('button, input, select').forEach((element) => element.disabled = false);
        for (const card of widget.querySelectorAll('.lc-card')) {
          const offer = this.offer(card.dataset.offer);
          if (offer.discountPercent && !offer.discountReady) card.querySelector('[data-lc-add]')?.setAttribute('disabled', '');
        }
        for (const option of widget.querySelectorAll('option')) {
          const card = option.closest('.lc-card');
          const product = this.products.get(Number(card?.dataset.product));
          option.disabled = !product?.variants.find((variant) => variant.id === Number(option.value))?.available;
        }
        if (completed) { widget.signature = null; this.render(widget); }
      }
    }
  }
  let nextId = 0;
  class ShoppingTools extends HTMLElement {
    connectedCallback() {
      this.instanceId ||= ++nextId;
      this.clickListener ||= (event) => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        const store = window.LabChestShopping;
        if (!store) return;
        if (button.hasAttribute('data-lc-direction')) {
          const rail = button.closest('.lc-offer').querySelector('.lc-cards');
          rail.scrollBy({ left: Number(button.dataset.lcDirection) * rail.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        } else if (button.hasAttribute('data-lc-add') || button.hasAttribute('data-lc-bundle')) {
          const cards = button.hasAttribute('data-lc-add') ? [button.closest('.lc-card')] : [...button.closest('.lc-offer').querySelectorAll('.lc-card')].filter((card) => card.querySelector('.lc-card__check')?.checked);
          store.add(this, cards, button).catch((error) => {
            const errors = this.querySelector('.lc-errors');
            if (errors) { errors.textContent = error.message; errors.hidden = false; }
          });
        }
      };
      this.changeListener ||= (event) => {
        const store = window.LabChestShopping;
        const card = event.target.closest('.lc-card');
        if (!store || !card) return;
        if (event.target.hasAttribute('data-variant-selector')) store.updateVariant(card);
        this.updateBundle(card.closest('.lc-offer'));
      };
      this.addEventListener('click', this.clickListener);
      this.addEventListener('change', this.changeListener);
      window.LabChestShopping?.register(this);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.clickListener);
      this.removeEventListener('change', this.changeListener);
      window.LabChestShopping?.widgets.delete(this);
    }
    updateBundle(group) {
      const button = group.querySelector('[data-lc-bundle]');
      const store = window.LabChestShopping;
      if (!button || !store) return;
      const cards = [...group.querySelectorAll('.lc-card')].filter((card) => card.querySelector('.lc-card__check')?.checked);
      const total = cards.reduce((sum, card) => {
        const variant = store.products.get(Number(card.dataset.product))?.variants.find((item) => item.id === Number(card.dataset.variant));
        const offer = store.offer(card.dataset.offer);
        return sum + Math.round((variant?.price || 0) * (1 - (offer.discountReady ? offer.discountPercent || 0 : 0) / 100)) * Number(card.querySelector('[data-quantity]')?.value || variant?.quantity_rule.min || 1);
      }, 0);
      button.textContent = text(store.config.strings.bundle, {amount: money(total, store.config)});
      button.disabled = !cards.length;
    }
  }
  if (!customElements.get('labchest-shopping-tools')) customElements.define('labchest-shopping-tools', ShoppingTools);
  if (!customElements.get('labchest-shopping-config')) customElements.define('labchest-shopping-config', ShoppingConfig);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-labchest-add-to-quote]');
      if (!button || button.disabled) return;

      const form = document.getElementById(button.dataset.productForm);
      const wrapper = button.closest('.labchest-product-quote');
      const status = wrapper.querySelector('.labchest-product-quote__status');
      const label = button.querySelector('span');
      const idleLabel = label.textContent;

      if (!form) {
        status.textContent = button.dataset.errorLabel;
        return;
      }

      wrapper.classList.add('is-loading');
      button.disabled = true;
      label.textContent = button.dataset.loadingLabel;
      status.textContent = '';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || button.dataset.errorLabel);
        }

        window.location.assign(button.dataset.redirect);
      } catch (error) {
        status.textContent = error instanceof Error ? error.message : button.dataset.errorLabel;
        wrapper.classList.remove('is-loading');
        button.disabled = false;
        label.textContent = idleLabel;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
